const colors = [
    ['153', '255', '221'],
    ['221', '255', '51'],
    ['153', '153', '255'],
];

export default class Star {
    constructor(width, height) {
        this.x = Math.random() * width; // 星のX座標
        this.y = Math.random() * height; // 星のY座標
        this.radius = Math.random() * 1.5; // 星の半径
        this.color = colors[Math.floor(Math.random() * 3)]; // 星の色
        this.alpha = Math.random(); // 透明度の初期化
        this.alphaChange = Math.random() * 0.05; // 透明度の変化量
    }

    update() {
        this.alpha += this.alphaChange;

        // 透明度が端に達したら反転
        if (this.alpha > 1 || this.alpha < 0) {
            this.alphaChange *= -1;
        }
    }

    draw(ctx) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${[...this.color]}, ${this.alpha})`;
        ctx.fill();
    }
}
